module.exports = __webpack_public_path__ + "static/media/mundon.76a22278.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mundon.gif
// module id = 157
// module chunks = 0